export { default } from '@triptyk/ember-utils/services/extended-store';
